import { Form, FormGroup, Nav, NavItem } from 'react-bootstrap';
import styled from 'styled-components';

export const MicrositeWrapper = styled.div`
    font-size: 16px;
    // margin-top: 50px;
    margin-bottom: 50px;
    // overflow-x: hidden;
    padding: 0;
    // transform: scale(0.85);
    // transform-origin: top left;

    * {
        font-family: 'Montserrat', sans-serif;
    }

    & > .wrap {
        margin: 0 auto;
        max-width: 856px;
    }

    & > #profile {
        background: url(/images/microsites/bg-profile.png) no-repeat center center #FFF;
        background-size: cover;
        height: 423px;
        // margin: 56px 0 0;
        padding: 1rem 3%;
    }

    & > #profile .wrap {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
    }

    & > #profile .image-column {
        width: 50%;
        position: relative;
    }

    & > #profile .text-column {
        padding: 0 0 0 135px;
        width: 50%;
    }

    & > #profile .image-column img {
        border: 8px solid #FFF;
        border-radius: 50%;
        width: 428px;
        height: 428px;
        position: relative;
        top: 14px;
        object-fit: cover;
    }

    & > #profile h1 {
        color: #000;
        font-size: 28px;
        font-weight: 700;
        line-height: 22px;
        margin: 0 0 5px;
    }

    & > #profile h1 + p,
    & > #profile label {
        color: #000;
        font-size: 15px;
        font-style: italic;
        font-weight: 400;
        line-height: 22px;
        margin: 0;
    }

    #profile label {
        margin: 30px 0 0;
    }

    & > #profile label + p {
        color: #CE0E2D;
        font-size: 18px;
        font-weight: 500;
        line-height: 22px;
    }

    & > #story {
        overflow: hidden;
        padding: 78px 3%;
    }

    & > #story .wrap {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
    }

    & > #story .label-column {
        text-align: right;
        width: 22.5%;
    }

    & > #story .label-column h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
    }

    & > #story .text-column {
        padding: 0 0 0 21px;
        width: 77.5%;
    }

    & > #story .text-column p {
        font-size: 16px;
        line-height: 22px;
    }

    /* - - - PHOTO SECTION  - - - */

    & > #gallery {
        background: #E6E6E6;
        font-size: 0;
        padding: 60px 3% 80px;
        text-align: center;
    }

    & > #gallery h1 {
        color: #000;
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 20px;
    }

    & > #gallery img {
        /*width: 100%;*/
        -webkit-transition: transform .3s ease-out;
        -moz-transition: transform .3s ease-out;
        -o-transition: transform .3s ease-out;
        transition: transform .3s ease-out;
        object-fit: cover;
        width: 200px;
        height: 100%;
    }

    & > #gallery a {
        border: 4px solid #FFF;
        display: inline-block;
        height: 215px;
        margin: 8px;
        overflow: hidden;
        position: relative;
        width: 215px;
        background-color: #fff;
    }

    & > #gallery a:hover img {
        transform: scale(1.05,1.05);
    }

    & > #gallery a::after {
        background: rgba(206, 14, 45, .1);
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transition: all .2s ease-out;
        -moz-transition: all .2s ease-out;
        -o-transition: all .2s ease-out;
        transition: all .2s ease-out;
    }

    & > #gallery a:hover::after {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }




    & > #call-to-action {
        background: #CE0E2D;
        border-bottom: 4px solid #FFF;
        padding: 40px 3%;
        text-align: center;
    }

    & > #call-to-action img {
        margin: 0 0 20px;
    }

    & > #call-to-action h1 {
        color: #FFF;
        font-size: 28px;
        font-weight: 700;
        line-height: 32px;
        margin: 0 0 15px;
    }

    & > #call-to-action p {
        color: #FFF;
        font-size: 16px;
        line-height: 22px;
        margin: 0 auto;
        max-width: 650px;
    }

    & > #call-to-action button {
        background: #FFF;
        border-radius: 4px;
        color: #000;
        display: inline-block;
        font-size: 15px;
        font-weight: 500;
        height: 40px;
        line-height: 19px;
        margin: 20px 6px 0;
        padding: 11px 10px;
        position: relative;
        text-decoration: none;
        min-width: 248px;
        -webkit-transition: all .3s ease-out;
        -moz-transition: all .3s ease-out;
        -o-transition: all .3s ease-out;
        transition: all .3s ease-out;
    }

    & > #call-to-action button:hover {
        background: #000;
        color: #FFF;
    }

    & > .no-glide {
        -webkit-transition-delay: 0s !important;
        transition-delay: 0s !important;
        -webkit-transition: none !important;
        transition: none !important;
    }

    .animate-left,
    .animate-right,
    .animate-down,
    .animate-down-left,
    .animate-down-right,
    .animate-up,
    .animate-up-left,
    .animate-up-right {
        opacity: 0;
        position: relative;
        z-index: 50;
        -webkit-transition: all .75s ease;
        -o-transition: all .75s ease;
        -moz-transition: all .75s ease;
        transition: all .75s ease;
    }

    .animate-left {
        left: 4.6875rem;
        top: 0;
    }

    .animate-left.animated {
        left: 0;
        top: 0;
    }

    .animate-right {
        right: 4.6875rem;
        top: 0;
    }

    .animate-right.animated {
        right: 0;
        top: 0;
    }

    .animate-up {
        top: 4.6875rem;
    }

    .animate-up.animated {
        top: 0;
    }

    .animated {
        opacity: 1;
        z-index: 50;
    }

    .animated,
    .animate-1 {
        -webkit-transition-delay: .3s;
        -moz-transition-delay: .3s;
        -o-transition-delay: .3s;
        transition-delay: .3s;
    }

    .animate-2 {
        -webkit-transition-delay: .5s;
        -moz-transition-delay: .5s;
        -o-transition-delay: .5s;
        transition-delay: .5s;
    }

    .animate-3 {
        -webkit-transition-delay: .7s;
        -moz-transition-delay: .7s;
        -o-transition-delay: .7s;
        transition-delay: .7s;
    }

    .animate-4 {
        -webkit-transition-delay: .9s;
        -moz-transition-delay: .9s;
        -o-transition-delay: .9s;
        transition-delay: .9s;
    }

    .animate-5 {
        -webkit-transition-delay: 1.1s;
        -moz-transition-delay: 1.1s;
        -o-transition-delay: 1.1s;
        transition-delay: 1.1s;
    }

    
`;

export const MicrositeWrapper2 = styled.div`
    font-size: 16px;
    margin-top: 50px;
    margin-bottom: 50px;
    overflow-x: hidden;
    padding: 0;

    * {
        font-family: 'Montserrat', sans-serif;
    }

    & > .wrap {
        margin: 0 auto;
        max-width: 856px;
    }

    & > #profile {
        background: url(/images/microsites/bg-profile.png) no-repeat center center #FFF;
        background-size: cover;
        height: 423px;
        margin: 56px 0 0;
        padding: 1rem 3%;
    }

    & > #profile .wrap {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
    }

    & > #profile .image-column {
        width: 50%;
        position: relative;
    }

    & > #profile .text-column {
        padding: 0 0 0 135px;
        width: 50%;
    }

    & > #profile .image-column img {
        border: 8px solid #FFF;
        border-radius: 50%;
        width: 428px;
        height: 428px;
        position: relative;
        top: 14px;
        object-fit: cover;
    }

    & > #profile h1 {
        color: #000;
        font-size: 28px;
        font-weight: 700;
        line-height: 22px;
        margin: 0 0 5px;
    }

    & > #profile h1 + p,
    & > #profile label {
        color: #000;
        font-size: 15px;
        font-style: italic;
        font-weight: 400;
        line-height: 22px;
        margin: 0;
    }

    #profile label {
        margin: 30px 0 0;
    }

    & > #profile label + p {
        color: #CE0E2D;
        font-size: 18px;
        font-weight: 500;
        line-height: 22px;
    }

    & > #story {
        overflow: hidden;
        padding: 78px 3%;
    }

    & > #story .wrap {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
    }

    & > #story .label-column {
        text-align: right;
        width: 22.5%;
    }

    & > #story .label-column h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
    }

    & > #story .text-column {
        padding: 0 0 0 21px;
        width: 77.5%;
    }

    & > #story .text-column p {
        font-size: 16px;
        line-height: 22px;
    }

    /* - - - PHOTO SECTION  - - - */

    & > #gallery {
        background: #E6E6E6;
        font-size: 0;
        padding: 60px 3% 80px;
        text-align: center;
    }

    & > #gallery h1 {
        color: #000;
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 20px;
    }

    & > #gallery img {
        /*width: 100%;*/
        -webkit-transition: transform .3s ease-out;
        -moz-transition: transform .3s ease-out;
        -o-transition: transform .3s ease-out;
        transition: transform .3s ease-out;
        object-fit: cover;
        width: 200px;
        height: 100%;
    }

    & > #gallery a {
        border: 4px solid #FFF;
        display: inline-block;
        height: 215px;
        margin: 8px;
        overflow: hidden;
        position: relative;
        width: 215px;
        background-color: #fff;
    }

    & > #gallery a:hover img {
        transform: scale(1.05,1.05);
    }

    & > #gallery a::after {
        background: rgba(206, 14, 45, .1);
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transition: all .2s ease-out;
        -moz-transition: all .2s ease-out;
        -o-transition: all .2s ease-out;
        transition: all .2s ease-out;
    }

    & > #gallery a:hover::after {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    /* - - - LIGHTBOX OVERRIDES  - - - */

    & > .sl-overlay {
        background: rgba(0,0,0,.9);
        opacity: 1;
    }

    & > .sl-wrapper .sl-close,
    & > .sl-wrapper .sl-navigation button.sl-prev,
    & > .sl-wrapper .sl-navigation button.sl-next {
        color: #FFF;
        font-size: 5rem;
    }

    & > .sl-wrapper .sl-close {
        margin-top: -25px;
    }

    & > .sl-wrapper .sl-image .sl-caption {
        color: #000;
        font-size: 14px;
        font-style: italic;
        font-weight: 500;
        background: rgba(255, 255, 255, 0.85);
    }

    /* - - - LIVING DONATION SECTION - - - */

    & >  #living-donation {
        padding: 130px 3% 180px;
        text-align: center;
    }

    & > #living-donation .wrap {
        max-width: 684px;
        width: 100%;
    }

    & > #living-donation h1 {
        color: #000;
        font-size: 28px;
        font-weight: 700;
        line-height: 32px;
        margin: 0 0 24px;
    }

    & > #living-donation p.intro {
        color: #000;
        font-size: 20px;
        line-height: 22px;
        margin: 0 auto 40px;
        max-width: 664px;
        width: 100%;
    }

    & > #living-donation .boxes {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        margin: 0 auto 45px;
        text-align: center;
        max-width: 562px;
        width: 100%;
    }

    & > #living-donation .box {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        background: #E6E6E6;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 177px;
        padding: 35px;
        width: 239px;
        -webkit-transition: background-color .3s ease-out;
        -moz-transition: background-color .3s ease-out;
        -o-transition: background-color .3s ease-out;
        transition: background-color .3s ease-out;
    }

    & > #living-donation .box:hover {
        background: rgba(206, 14, 45, .1)
    }

    & > #living-donation .box span:not(.or-span) {
        color: #CE0E2D;
        font-size: 40px;
        font-weight: 700;
        line-height: 22px;
        margin: 0 0 10px;
    }

    & > #living-donation .box p {
        color: #000;
        font-size: 16px;
        line-height: 22px;
        width: 100%;
    }

    /* - - - DONOR INFO SECTION - - - */

    & > #donor-info {
        background: rgba(0,0,0,.1);
        padding: 0 3% 90px;
    }

    & > #donor-info .wrap {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        max-width: 1005px;
        width: 100%;
    }

    & > #donor-info .wrap .text-column {
        flex: 1 1 0;
        max-width: 460px;
        position: relative;
        width: 100%;
    }

    & > #donor-info .wrap .text-column:first-child {
        margin-right: 2rem;
    }

    & > #donor-info .wrap .text-column:last-child {
        margin-left: 2rem;
    }

    & > #donor-info img {
        border: 8px solid #E6E6E6;
        margin-bottom: -30%;
        max-width: 100%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    & > #donor-info h2 {
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        margin: 42px 0 15px;
    }

    & > #donor-info p {
        font-size: 16px;
        line-height: 22px;
        margin: 0 0 18px;
        max-width: 460px;
    }

    & > #donor-info ul {
        list-style-type: none;
        padding: 0 0 0 18px;
    }

    & > #donor-info ul li {
        margin: 0 0 24px 48px;
        padding-right: 35px;
        position: relative;
    }

    & > #donor-info ul li::before {
        content: '\02022';
        position: absolute;
        left: -50px;
    }

    & > #donor-info a {
        color: #428BCA;
        -webkit-transition: color .3s ease-out;
        -moz-transition: color .3s ease-out;
        -o-transition: color .3s ease-out;
        transition: color .3s ease-out;
    }

    & > #donor-info a:hover {
        color: #CE0E2D;
        text-decoration: none;
    }

    /* - - - DONATION TYPES SECTION - - - */

    & > #donation-types {
        overflow: hidden;
        padding: 80px 3%;
        text-align: center;
    }

    & > #donation-types .wrap {
        max-width: 1005px;
    }

    & > #donation-types h1 {
        background: #FFF;
        display: inline-block;
        font-size: 28px;
        font-weight: 700;
        margin: 0 auto;
        padding: 0 20px;
    }

    & > #donation-types h1 + .divider {
        margin-bottom: 0;
        position: relative;
        top: -85px;
        z-index: -1;
    }

    & > #donation-types .divider {
        background: rgba(0,0,0,.2);
        display: block;
        height: 1px;
        margin: 72px 0;
    }

    & > #donation-types .donation-row {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    & > #donation-types .text-column {
        text-align: left;
        width: 625px;
    }

    & > #donation-types .text-column p {
        font-size: 16px;
        line-height: 22px;
        margin: 0 0 16px;
    }

    & > #donation-types .image-column img {
        max-width:100%;
    }

    & > #donation-types .pad-left {
        padding-left: 50px;
    }

    & > #donation-types .pad-right {
        padding-right: 40px;
    }

    & > #donation-types .btn-danger {
        background: #CE0E2D;
        border-radius: 4px;
        color: #FFF;
        display: inline-block;
        height: 40px;
        font-size: 15px;
        font-weight: 500;
        margin: 12px 0;
        padding: .9rem 0;
        text-align: center;
        text-decoration: none;
        -webkit-transition: background-color .3s ease-out;
        -moz-transition: background-color .3s ease-out;
        -o-transition: background-color .3s ease-out;
        transition: background-color .3s ease-out;
        width: 200px;
    }

    & > #donation-types .btn-danger:hover {
        background: #000;
    }

    & > #donation-types .donation-row:last-child .btn-danger {
        margin-bottom: 60px;
    }

    /* - - - CALL TO ACTION  - - - */

    & > #call-to-action {
        background: #CE0E2D;
        border-bottom: 4px solid #FFF;
        padding: 40px 3%;
        text-align: center;
    }

    & > #call-to-action img {
        margin: 0 0 20px;
    }

    & > #call-to-action h1 {
        color: #FFF;
        font-size: 28px;
        font-weight: 700;
        line-height: 32px;
        margin: 0 0 15px;
    }

    & > #call-to-action p {
        color: #FFF;
        font-size: 16px;
        line-height: 22px;
        margin: 0 auto;
        max-width: 650px;
    }

    & > #call-to-action button {
        background: #FFF;
        border-radius: 4px;
        color: #000;
        display: inline-block;
        font-size: 15px;
        font-weight: 500;
        height: 40px;
        line-height: 19px;
        margin: 20px 6px 0;
        padding: 11px 10px;
        position: relative;
        text-decoration: none;
        min-width: 248px;
        -webkit-transition: all .3s ease-out;
        -moz-transition: all .3s ease-out;
        -o-transition: all .3s ease-out;
        transition: all .3s ease-out;
    }

    & > #call-to-action button:hover {
        background: #000;
        color: #FFF;
    }

    /* PAGE SCROLL ANIMATIONS ------------------------------ */

    & > .no-glide {
        -webkit-transition-delay: 0s !important;
        transition-delay: 0s !important;
        -webkit-transition: none !important;
        transition: none !important;
    }

    & > .animate-left,
    & > .animate-right,
    & > .animate-down,
    & > .animate-down-left,
    & > .animate-down-right,
    & > .animate-up,
    & > .animate-up-left,
    & > .animate-up-right {
        opacity: 0;
        position: relative;
        z-index: 50;
        -webkit-transition: all .75s ease;
        -o-transition: all .75s ease;
        -moz-transition: all .75s ease;
        transition: all .75s ease;
    }

    & > .animate-left {
        left: 4.6875rem;
        top: 0;
    }

    & > .animate-left.animated {
        left: 0;
        top: 0;
    }

    & > .animate-right {
        right: 4.6875rem;
        top: 0;
    }

    & > .animate-right.animated {
        right: 0;
        top: 0;
    }

    & > .animate-up {
        top: 4.6875rem;
    }

    & > .animate-up.animated {
        top: 0;
    }

    .animated {
        opacity: 1;
        z-index: 50;
    }

    .animated,
    .animate-1 {
        -webkit-transition-delay: .3s;
        -moz-transition-delay: .3s;
        -o-transition-delay: .3s;
        transition-delay: .3s;
    }

    .animate-2 {
        -webkit-transition-delay: .5s;
        -moz-transition-delay: .5s;
        -o-transition-delay: .5s;
        transition-delay: .5s;
    }

    .animate-3 {
        -webkit-transition-delay: .7s;
        -moz-transition-delay: .7s;
        -o-transition-delay: .7s;
        transition-delay: .7s;
    }

    .animate-4 {
        -webkit-transition-delay: .9s;
        -moz-transition-delay: .9s;
        -o-transition-delay: .9s;
        transition-delay: .9s;
    }

    .animate-5 {
        -webkit-transition-delay: 1.1s;
        -moz-transition-delay: 1.1s;
        -o-transition-delay: 1.1s;
        transition-delay: 1.1s;
    }

    /* - - - MEDIA QUERIES - - - */

    @media (max-width: 1250px) {
        #gallery a {height:180px;width:180px;}
    }

    @media (max-width: 1100px) {
        #gallery a {height:170px;width:170px;}
    }

    @media (max-width: 1050px) {
        .navbar-inverse .navbar-nav>li>a {margin: 0;padding: 18px 8px 15px;}
    }

    @media (max-width: 1024px) {
        #gallery a {height:215px;width:215px;}
        #gallery .spacer {display: block;}
        & > #donor-info .wrap {-webkit-box-pack: center;-ms-flex-pack: center;justify-content: center;}
    }

    @media (max-width: 991px) {
        & > #donation-types h1 {font-size: 22px;}
        footer .container {width: 100%;}
    }

    @media (max-width: 900px) {
        #logo {width: 250px; margin:3px 0 0;}
    }

    @media (max-width: 850px) {
        & > #donor-info ul li {margin: 0 0 24px 20px;}
        & > #donor-info ul li::before {left: -20px;}
        footer .divider {display: none;}
        footer span a:first-of-type {margin-left: 0;}
        footer span {display: block;margin: 10px 0 0;}
        footer p {top: 2px;}
        footer #social-media {margin: 2px 0 0;padding: 0 15px;}
        footer #social-media a {margin: 0 .5rem 0 0;}
    }

    @media (max-width: 830px) {
        #logo {margin:5px 0 0;width: 200px;}
    }

    @media (max-width: 800px) {
        .navbar-inverse .navbar-nav>li>a {padding: 18px 6px 15px;}
    }

    @media (max-width:767px) {
        #logo {margin-top: 1px;width: 280px;}
        .navbar-nav {float: none;padding: 0 0 2rem;}
        .navbar-inverse .navbar-nav>li{height:40px;}
        .navbar-inverse .navbar-nav>li>a {height: auto;padding: 10px 8px;margin:4px 0;}
        .dropdown-menu {background: #000;margin: 0 0 2rem;position: relative;width: 100%;}
        .dropdown-menu>li>a {color: #FFF;}
        .navbar-inverse .btn-danger {top: 0;}
        #profile {height: 380px;}
        #profile .image-column img {width: 380px;height: 380px;}
        #profile h1 {font-size: 24px;}
        #profile .text-column {padding: 0 0 0 100px;}
        #profile label {margin: 20px 0 0;}
        #gallery .spacer {display: none;}
        #living-donation {padding: 100px 3% 180px; text-align: center;}
        #living-donation h1 {font-size: 22px;}
        #living-donation p.intro {font-size: 18px;}
        & > #donor-info {padding: 0 3% 30px;}
        & > #donor-info .wrap,
        & > #donation-types .donation-row {-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}
        & > #donation-types .wrap .donation-row:nth-child(5) {-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;}
        & > #donor-info .wrap .text-column:first-child {margin: 0 auto;}
        & > #donor-info .wrap .text-column:last-child {margin:20px auto;}
        & > #donor-info .wrap .text-column:last-child img {-webkit-transform: none;transform: none;margin: 0;}
        & > #donation-types { padding: 60px 3% 40px;}
        & > #donation-types h1 {margin-bottom: 40px;}
        & > #donation-types h1 + .divider {display:none;}
        & > #donation-types .pad-left, & > #donation-types .pad-right {padding: 0;}
        & > #donation-types .donation-row .text-column,& > #donation-types .donation-row .image-column {margin-bottom: 30px;}
        & > #donation-types .text-column { width: 90%;}
        & > #donation-types .donation-row:last-child .btn-danger {margin-bottom: 30px;}
        & > #donation-types .divider {margin: 20px 0 50px;}
    }

    @media (max-width: 685px) {
        #profile {height: 325px;}
        #profile .image-column img {width: 325px;height:325px;}
        #profile h1 {font-size: 22px;}
        #profile .text-column {padding: 0 0 0 80px;}
        #profile label {margin: 15px 0 0;}
    }

    @media (max-width: 575px) {
        #profile {height: 285px;}
        #profile .image-column img {width: 285px;height:285px;}
        #profile h1 {font-size: 20px;}
        #profile label + p { font-size: 16px;}
        #profile .text-column {padding: 0 0 0 70px;}
        #profile label {margin: 10px 0 0;}
        #living-donation .boxes {-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}
        .or-span {margin: 2rem 0;}
    }

    @media (max-width: 550px) {
        #gallery a {height: 200px;width: 200px;}
        footer span {margin: 12px 0 0;}
        footer #copyright {padding: 8px 15px 0;width: 100%;}
        footer p {top: 0;}
        footer a {margin: 0 2px;}
        footer #social-media {margin:16px 0 0;text-align: left;width: 100%;}
    }

    @media (max-width: 530px) {
        #profile {height: auto; padding: 30px 3%;}
        #profile .image-column {width: 100%;}
        #profile .image-column img {display: block; margin: 0 auto 30px; top:0;}
        #profile .text-column {padding: 0; text-align: center; width: 100%;}
        #story {padding: 45px 3% 35px;}
        #story .label-column {margin: 0 0 8px; text-align: left; width:100%;}
        #story .text-column {width: 100%; padding: 0; margin: 0 0 16px;}
        #gallery {padding: 55px 3%;}
    }

    @media (max-width: 480px) {
        #logo {margin-top: 1px;width: 225px;}
        #gallery a {height: 170px; width: 170px;}
    }

    @media (max-width: 420px) {
        #gallery a {height: 215px; width: 215px;}
    }

    
`;

export const TableWrapper = styled.table`
    margin-bottom: 0px;
    
    & > thead > tr {
        background-color: #ddd;
    }

    & > thead > tr > th:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    & > thead > tr > th:last-child {
        border-right: 1px solid #ddd;
    }

    & > thead > tr > th {
        text-align: center;
        border: 1px solid white;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > thead > tr > th {
        position: sticky;
        top: -1px;
        background-color: rgb(221, 221, 221) !important;
    }

    & > thead > tr:nth-child(2) > th {
        position: sticky;
        top: 25px;
        background-color: #dfe7f1 !important;
    }
`;

export const GridWrapper = styled.div`
    height: 76vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 73vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        background-color: rgb(221, 221, 221);
        color: #000000;
        font-size: 12px;
        font-weight: bold;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 12px;
        /* padding-bottom: 5px; */
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
        /* padding-bottom: 5px; */
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
        font-size: 12px;
    }

   .ag-row {
        z-index: 0;
    }

     .ag-row.ag-row-hover {
     background-color: #eaf2fa;
     }

    .donor-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-body-viewport {
        border-left: 1px solid rgb(204, 204, 204);
        border-right: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
    }

    .ag-icon {
        color: white;
    }

    .customSortUpLabel,
    .customSortDownLabel {
        margin-left: 3px;
    }
`;

export const CenterGridWrapper = styled.div`
    width: 100%;
    height: 55vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        overflow-y: scroll;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .microsite-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 26px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .microsite-list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    /* Coach column (center list: coach name only, no dropdown): full-cell hover target for email popover */
    div.coach-drop-cell {
        padding: 0;
    }

    .ag-cell.coach-drop-cell,
    .ag-cell.coach-drop-cell .ag-cell-wrapper,
    .ag-cell.coach-drop-cell .ag-react-container {
        overflow: visible;
    }

    .coach-drop-cell .coach-email-popover-trigger {
        width: 100%;
        min-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    }

    .coach-drop-cell .coach-email-popover-label {
        width: 100%;
        text-align: center;
    }

    .microsite-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .microsite-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .microsite-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;

export const AdminGridWrapper = styled.div`
    width: 100%;
    height: 64vh;

    .microsite-list-cell .coach-drop {
        height:24px;
        width: 100%;
        padding: 0;
    }   

    div.coach-drop-cell {
        padding: 0;
    }

    .ag-cell.coach-drop-cell,
    .ag-cell.coach-drop-cell .ag-cell-wrapper,
    .ag-cell.coach-drop-cell .ag-react-container {
        overflow: visible;
    }

    /* Coach column (admin: select dropdown): trigger fills cell so hover works like text-only center view */
    .coach-drop-cell .coach-email-popover-trigger {
        width: 100%;
        min-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    }

    .coach-drop-cell .coach-email-popover-trigger .coach-drop {
        flex: 1 1 auto;
        min-width: 0;
    }

    /* Disabled selects do not bubble hover to parent; let the wrapper receive pointer events for the email popover. */
    .coach-drop-cell .coach-email-popover-trigger select.coach-drop:disabled {
        pointer-events: none;
    }

    .action-menu {
        overflow: visible;
        /* border-bottom: none; */
        // line-height: 33px;
        /* border-color: #ccc; */
        display: flex;
        align-items: center;
        border: 0 none;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .microsite-list-cell {
        //border-bottom: none;
        text-align: center;
        line-height: 26px;
        //border-color: #ccc;
        // font-size: 12px;
        border: 0 none;
        border-right: 1px solid #ddd;
    }

    .microsite-list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    .microsite-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .microsite-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-right: 1px solid white;
    }

    .microsite-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    .coach-drop option, .coach-drop optgroup {
        color: #555;
        text-decoration: none;
    }

    .coach-drop option.option-deleted {
        color: red;
        text-decoration: line-through;
        cursor: not-allowed;
    }

    .coach-drop.option-deleted {
        color: red;
        text-decoration: line-through;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    display: flex;
    align-items: center;

    & > .control-label {
        margin-bottom: 0px;
    }
`;

export const FormWrapper = styled(Form)`
    .form-group {
        margin-bottom: 10px;
    }

    .help-block {
        margin-bottom: 0px;
    }

    @media (min-width: 768px) {
        .form-group > .control-label {
            // text-align: left !important;
        }
    }

    .coach-drop option, .coach-drop optgroup {
        color: #555;
        text-decoration: none;
    }

    .coach-drop option.option-deleted {
        color: red;
        text-decoration: line-through;
        cursor: not-allowed;
    }

    .coach-drop.option-deleted {
        color: red;
        text-decoration: line-through;
    }
`;

export const CampaignGridWrapper = styled.div`
    width: 100%;
    height: 62vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        overflow-y: scroll;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .campaign-list-cell {
        border-bottom: none;
        text-align: center;
        // line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .campaign-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        // line-height: 33px;
        border-color: #B7B7B7;
    }

    .campaign-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .campaign-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    // & > li {
    //     height: 52px;
    // }

    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .ms-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }

    & > div > .ms-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
        // min-height: 72px;
    }

    & > div > .ms-pills > li.li-divider {
        height: 50px;
        display: flex;
        align-items: center;
    }

    & > div > .ms-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        // margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid red;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

interface INavItemProps {
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    // }

    height: 50px;
    display: flex !important;
    align-items: center;
    text-align: center;

    & > a {
        // border-radius: 8px !important;
        // text-align: center;
        // border: 1px solid #337ab7;
        // min-height: 72px;
    }

    & > a > span.badge {
        font-size: 10px;
    }

    & > a > span.type-count {
        font-size: 12px;
    }
`;

export const HistoryGridWrapper = styled.div`
    height: 500px;
    width: 100%;
    margin-top: 10px;

    .event-row {
        background-color: rgba(240, 248, 255, 0.5); // Light blue tint for events
        &:hover {
            background-color: rgba(240, 248, 255, 0.8);
        }
    }

    .status-row {
        background-color: rgba(245, 245, 245, 0.5); // Light gray tint for status
        &:hover {
            background-color: rgba(245, 245, 245, 0.8);
        }
    }

    .approval-row {
        background-color: rgba(255, 248, 240, 0.5); // Light orange tint for approval status
        &:hover {
            background-color: rgba(255, 248, 240, 0.8);
        }
    }

    .list-header {
        background-color: #f5f5f5;
        font-weight: bold;
        padding: 8px;
    }

    .list-cell {
        border-right: 1px solid #ddd;
        padding: 4px 8px;
        display: flex;
        align-items: center;
    }

    .label {
        padding: 4px 8px;
        font-size: 12px;
        font-weight: normal;
        border-radius: 3px;
        display: inline-block;
        line-height: 1;

        &.label-warning {
            background-color: #f0ad4e;
            color: white;
        }

        &.label-success {
            background-color: #5cb85c;
            color: white;
        }

        &.label-danger {
            background-color: #d9534f;
            color: white;
        }

        &.label-info {
            background-color: #5bc0de;
            color: white;
        }
    }
`;

export const HistoryTitle = styled.h4`
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
    color: #333;
`;

export const AddEditWrapper = styled.div`
    .validation-section + .validation-section {
        margin-bottom: 10px;
    }
`;

export const DisabledFormControl = styled.div`
    cursor: not-allowed;
    background-color: #eee;
    opacity: 1;
`;